const RADIOBAR_ITEM_LEFT = 0;
const RADIOBAR_ITEM_RIGHT = 1;
const RADIOBAR_ITEM_UP = 2;
const RADIOBAR_ITEM_DOWN = 3;
const RADIOBAR_ITEM_TAB = 4;
const RADIOBAR_ITEM_SPACE = 5;
const RADIOBAR_ITEM_CLICK = 6;
const RADIOBAR_ITEM_FOCUSED = 7;
export {
  RADIOBAR_ITEM_CLICK,
  RADIOBAR_ITEM_DOWN,
  RADIOBAR_ITEM_FOCUSED,
  RADIOBAR_ITEM_LEFT,
  RADIOBAR_ITEM_RIGHT,
  RADIOBAR_ITEM_SPACE,
  RADIOBAR_ITEM_TAB,
  RADIOBAR_ITEM_UP
};
